<div
  class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 py-2"
  [style]="!label() ? 'display:flex; w-full' : ''"
>
  @if (label()) {
    <label [for]="fieldId()" [class]="labelClass()">
      {{ label() }}
      @if (isRequired()) {
        <span aria-hidden="true" class="text-red-500">*</span>
      }
    </label>
  }

  @if (type() !== 'textarea') {
    <div [class]="!label() ? 'w-full' : 'sm:col-span-2'">
      <div [class]="inputContainerClass()">
        <input
          [id]="fieldId()"
          [type]="type() === 'password' && showPassword() ? 'text' : type()"
          [placeholder]="placeholder()"
          [formField]="formField()"
          [class]="inputClass()"
          [attr.aria-required]="isRequired() || undefined"
          [attr.aria-invalid]="isInvalid() || undefined"
          [attr.aria-describedby]="isInvalid() && invalidPlaceholder() ? errorId() : undefined"
          [style.width]="type() === 'password' ? '80%' : ''"
          (change)="valueChanged.emit()"
        />
        @if (type() === 'password') {
          <button
            type="button"
            (click)="togglePasswordVisibility()"
            class="mr-4 z-10 text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <span class="sr-only"></span>
            @if (showPassword()) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="var(--color-primary-500)"
              >
                <path
                  d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
                />
              </svg>
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="var(--color-primary-500)"
              >
                <path
                  d="M607.5-372.5Q660-425 660-500t-52.5-127.5Q555-680 480-680t-127.5 52.5Q300-575 300-500t52.5 127.5Q405-320 480-320t127.5-52.5Zm-204-51Q372-455 372-500t31.5-76.5Q435-608 480-608t76.5 31.5Q588-545 588-500t-31.5 76.5Q525-392 480-392t-76.5-31.5ZM214-281.5Q94-363 40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200q-146 0-266-81.5ZM480-500Zm207.5 160.5Q782-399 832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280q113 0 207.5-59.5Z"
                />
              </svg>
            }
          </button>
        }
      </div>
      @if (isInvalid() && invalidPlaceholder()) {
        <p [id]="errorId()" role="alert" class="mt-1 text-sm text-red-500 dark:text-red-400">
          {{ invalidPlaceholder() }}
        </p>
      }
    </div>
  } @else {
    <div class="sm:col-span-2">
      <textarea
        [id]="fieldId()"
        rows="4"
        [formField]="formField()"
        [placeholder]="placeholder()"
        [attr.aria-required]="isRequired() || undefined"
        [attr.aria-invalid]="isInvalid() || undefined"
        [attr.aria-describedby]="isInvalid() && invalidPlaceholder() ? errorId() : undefined"
        class="block w-full rounded-md bg-white dark:bg-gray-900/50 px-3 py-1.5 text-base outline-1 -outline-offset-1 outline-gray-300 dark:outline-gray-900 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 sm:text-sm/6 sm:max-w-md"
      ></textarea>
      @if (isInvalid() && invalidPlaceholder()) {
        <p [id]="errorId()" role="alert" class="mt-1 text-sm text-red-500 dark:text-red-400">
          {{ invalidPlaceholder() }}
        </p>
      }
    </div>
  }
</div>
